<template>
  <div v-if="body_show">
    <div class="task_f">
      <div class="valuation">
        <div class="valuation_content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getcheck
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        content: "",
      }
    },
    methods: {
      pullData() {
        getcheck({
            type: "self",
            cid: this.$route.query.cid,
            id: this.$route.query.id
          })
          .then((data) => {
            this.body_show = true;
            this.content = data.content;
            // 神策统计--自查清单
            sensors.track('projectWorkbox', {
              course_id: this.$route.query.cid,
              course_name: data.coursename,
              project_id: data.cpid + '',
              project_name: data.projectname,
              workbox_type: "自查清单",
              workbox_name: "自查清单",
            });
          })

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.task_f {
  margin: 0 auto;
  text-align: left;
  width: 750px;
}

.valuation {
  text-align: left;
  background: #fff;
  padding: changeRem(.6)+px;
  width: 750px;
  margin-top: changeRem(.6)+px;
  .valuation_content {
    margin: 0 auto;
    width: 100%;
  }
}
</style>
<style>
img {
  width: 100%
}
</style>
